import HttpService from "./HttpService";
import { LocalStorage } from "../utils/Utils";

let inFlightSyncPromise: Promise<any> | null = null;

/**
 * Utility to deduplicate simultaneous calls to /candidate/sync_dashboard.
 * Reuses the active promise if a request is already in-flight.
 */
export const fetchSyncDashboard = (api: HttpService): Promise<any> => {
  if (inFlightSyncPromise) {
    return inFlightSyncPromise;
  }

  api.setAuthToken(LocalStorage.getLocalData("access_token"));
  inFlightSyncPromise = api
    .get<any>("/candidate/sync_dashboard")
    .finally(() => {
      inFlightSyncPromise = null;
    });

  return inFlightSyncPromise;
};
